import React from 'react'
import Header from '../Landing/Header/Header'
import "./privacypolicy.scss";
import Luckify from '../Landing/Luckify/Luckify';
import Footer from '../Landing/Footer/Footer';

const Privacypolicy = () => {
    return (
        <>
            <Header />
            <div className='privacy_mains'>
                <section className='inner_privacy'>
                    <div className='inner_text'>
                        <h2>Privacy Policy</h2>
                        <h3>Effective Date: 30.06.2025</h3>
                    </div>

                    <video
                        className="main-banner-video"
                        muted="muted"
                        playsinline="playsinline"
                        autoPlay
                        loop
                        width="100%"
                        id="myVideo"
                    >
                        <source src="/assets/bannerassets/luckifybg.mp4" type="video/mp4" />
                    </video>
                    <img
                        src="/assets/bannerassets/bannertopshade.png"
                        alt="bannertopshade"
                        className="bannertopshade"
                    />
                    {window.innerWidth < 991 ?
                        <img
                            src="/assets/bannerassets/bannerlinesmbl.png"
                            alt="bannerlines"
                            className="bannerlines"
                        />
                        :
                        <img
                            src="/assets/bannerassets/bannerlines.png"
                            alt="bannerlines"
                            className="bannerlines"
                        />
                    }
                </section>
                <div className='bottom_data'>
                    <div className='custom-container'>
                        <h4>1. Introduction</h4>
                        <p>This Privacy Policy explains how Luckify (“Luckify”, “we”, “our”, or “us”) collects, uses, discloses, and protects information obtained from users (“you”, “your”) of the website https://www.luckify.bet/ (“Site”).</p>
                        <h4>2. Scope</h4>
                        <p>This Policy applies to data processed via the Site, decentralized applications (dApps), and related services. As a decentralized platform, Luckify minimizes data collection and prioritizes user privacy. </p>

                        <h4>3. Data We Collect</h4>
                        <h5>3.1 Wallet Information:</h5>
                        <h6>We collect wallet addresses you connect to interact with the platform. This is necessary for gameplay and smart contract operations. </h6>


                        <h5>3.2 Technical Information:</h5>
                        <h6>We may collect limited device and usage information (e.g., IP address, browser type) for performance and security monitoring.</h6>


                        <h5>3.3 Optional Contact Information:</h5>
                        <h6>If you contact us directly (e.g., via email or support forms), we may collect your contact details to respond to inquiries. </h6>



                        <h5>3.3 Optional Contact Information:</h5>
                        <p>If you contact us directly (e.g., via email or support forms), we may collect your contact details to respond to inquiries. </p>


                        <h4>4. Use of Data</h4>
                        <p>We use your information solely to: - Enable interaction withdecentralized games and randomness tools; - Ensure platform integrity and prevent abuse; - Respond to user inquiries; - Comply with applicable legal and regulatory obligations.</p>


                        <h4>5. Sharing of Information</h4>
                        <p>We do not sell or rent user data. We may disclose information only: - To service providers assisting with infrastructure or security (under confidentiality); - To comply with legal or regulatory requirements; - In the context of a merger, acquisition, or asset transfer, limited to necessary information.</p>




                        <h4>6. Decentralization and Data Minimization</h4>
                        <p>Luckify is a non-custodial and decentralized service. We do not store private keys or hold user funds. Game outcomes and randomness proofs are recorded on-chain and are public by design.</p>


                        <h4>7. Cookies and Tracking</h4>
                        <p>The Site may use minimal cookies for basic session functionality. We do not use third-party ad trackers or behavioral profiling tools.</p>



                        <h4>8. Security</h4>
                        <p>We apply reasonable technical measures to secure your interactions with the Site. However, blockchain interactions carry inherent risks, and we advise using secure wallets and network practices.</p>



                        <h4>9. International Data Transfers</h4>
                        <p>By using our Site, you understand that your data may be processed outside your jurisdiction, subject to appropriate safeguards where required by law.</p>



                        <h4>10. Your Rights</h4>
                        <p>Depending on your location, you may have rights to access, correct, or delete your personal information. Please contact us at [Insert Contact Email] for such requests.</p>

                        <h4>11. Exclusions</h4>
                        <p>This Policy does not cover third-party dApps or services accessed via the Site. We encourage you to review their policies separately</p>



                        <h4>12. Changes to This Policy</h4>
                        <p>We may update this Privacy Policy periodically. Updates will be posted on the Site with a new effective date.</p>


                        <h4>13. Contact Us</h4>
                        <p>For any questions or privacy-related concerns, contact us at: [Insert Contact Email]</p>
                    </div>

                </div>
            </div>
            <Footer/>
        </>
    )
}

export default Privacypolicy
